import { useQuery } from '@apollo/client';
import { GET_APPLICATION_CONFIG } from 'graphql/member';
import { useEffect, useState } from 'react';
import { AccreditationType } from 'graphql/__generated__/graphql';

export const useAccreditationTypes = () => {
    // Queries
    const { data, loading, error } = useQuery(GET_APPLICATION_CONFIG);

    // State
    const [accreditationTypes, setAccreditationTypes] = useState<AccreditationType[]>([]);

    // Process config data when it loads
    useEffect(() => {
        if (!loading && !error && data?.activeAccreditationTypes) {
            setAccreditationTypes(data.activeAccreditationTypes);
        }
    }, [loading, error, data]);

    return {
        accreditationTypes,
        error,
        loading,
    };
};
